<template>
  <div class="row">
    <div class="col-md-12">
      
    </div>
    <div class="col-md-12">
      <div class="card">
         <div class="card-body">
        
          <div class="col-sm-12">
            <el-table class="table-striped"
                      :data="tableData"
                      stripe
                      border
                      style="width: 100%">
              
              <el-table-column
                prop="name"
                label=""
                minWidth="120">
              </el-table-column>
              <el-table-column
                prop="description"
                label="Description"
                minWidth="300">
                <template slot-scope="scope">
                  <router-link :to="{name: scope.row.routeName }">
                    {{ scope.row.description }}
                  </router-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn} from 'element-ui'
  
  Vue.use(Table)
  Vue.use(TableColumn)
  
  export default{
    
    data () {
      return {
        tableColumns: [
         {
            prop: 'name',
            label: '',
            minWidth: 120
          },
          {
            prop: 'description',
            label: 'Description',
            minWidth: 300
          }
        ],
        tableData: [{
          name: 'Monthly Budget',
          routeName: 'Monthly Budget',
          description: 'The total amount you want to spend monthly. We recommend this is 70% of your total income.',
        },
        {
          name: 'Monthly Income',
          routeName: 'Monthly Income',
          description: 'The sum of all that you earn monthly.',
        },
        {
          name: 'Categories',
          routeName: 'My Categories',
          description: 'Group similar expenses or income together. Works for your budget and transactions.'
        },
        {
          name: 'Linked Accounts',
          routeName: 'My Accounts',
          description: 'Link accounts that you want to automatically track inflow and outflow.'
        }]
      }
    },

  }
</script>
<style>
</style>
